import { Box, Typography, Grid } from '@mui/material';
import { ThemePalette } from 'mui.theme';
import { Details } from './Details';
import { SupportingChart } from './SupportingChart';
import { AnalysisChart } from './AnalysisChart';
import type { SquaresAlert } from 'types/squares.type';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const ChartView = ({
  enableDarkTheme,
  notification,
}: {
  enableDarkTheme: boolean;
  notification: SquaresAlert;
}) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const { t } = useTranslation();
  const fontColor = palette.textPrimary;

  return (
    <Box>
      <Details enableDarkTheme={enableDarkTheme} notification={notification} />
      <Grid container spacing={2}>
        <Grid item lg={3}>
          <Typography
            sx={{
              fontSize: '12px',
              color: ThemePalette.typography.grey,
              fontWeight: '600',
            }}
          >
            {t('detected_at')}
          </Typography>
          <Typography
            sx={{
              marginTop: '10px',
              fontSize: '14px',
              fontWeight: '600',
              color: fontColor,
            }}
          >
            {t('25_nov_2025_10_08_am')}
          </Typography>
        </Grid>
        <Grid item lg={9}>
          <Typography
            sx={{
              fontSize: '12px',
              color: ThemePalette.typography.grey,
              fontWeight: '600',
            }}
          >
            {t('impacted_subsystems')}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignContent: 'center',
              marginTop: '5px',
            }}
          >
            <Box
              sx={{
                display: 'inline-block',
                backgroundColor: 'rgba(242, 181, 68, 0.25)',
                border: '1px solid rgba(242, 181, 68, 0.25)',
                color: '#F5B544',
                padding: '6px 16px',
                borderRadius: '999px',
                fontSize: '14px',
                fontWeight: 600,
                backdropFilter: 'blur(1px)',
                marginRight: '10px',
              }}
            >
              {t('engine_cooling_system_radiator_coolant_hoses_water_pump')}
            </Box>

            <Box
              sx={{
                display: 'inline-block',
                backgroundColor: 'rgba(242, 181, 68, 0.25)',
                border: '1px solid rgba(242, 181, 68, 0.25)',
                color: '#F5B544',
                padding: '6px 16px',
                borderRadius: '999px',
                fontSize: '14px',
                fontWeight: 600,
                backdropFilter: 'blur(1px)',
              }}
            >
              {t('engine_block_head')}
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          marginTop: '20px',
        }}
      >
        <Typography
          sx={{
            fontSize: '12px',
            color: ThemePalette.typography.grey,
            fontWeight: '600',
          }}
        >
          {t('description')}
        </Typography>
        <Typography
          sx={{
            fontSize: '12px',
            color: fontColor,
            marginTop: '10px',
          }}
        >
          {notification.message}
        </Typography>
      </Box>

      <Box
        sx={{
          marginTop: '20px',
        }}
      >
        <Typography
          sx={{
            fontSize: '12px',
            color: ThemePalette.typography.grey,
            fontWeight: '600',
          }}
        >
          {t('supporting_evidence')}
        </Typography>
        <Box
          sx={{
            marginTop: '10px',
            border: '1px solid #2F445E',
            borderRadius: '4px',
            padding: '10px',
          }}
        >
          <SupportingChart />
        </Box>
      </Box>

      <Box
        sx={{
          marginTop: '20px',
        }}
      >
        <Typography
          sx={{
            fontSize: '12px',
            color: ThemePalette.typography.grey,
            fontWeight: '600',
          }}
        >
          {t('ml_impact_analysis')}
        </Typography>
        <Box
          sx={{
            marginTop: '10px',
            border: '1px solid #2F445E',
            borderRadius: '4px',
            padding: '10px',
          }}
        >
          <AnalysisChart />
        </Box>
      </Box>
    </Box>
  );
};
